import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import Example from './example.js';
import ExampleTwo from './example2.js';
import ExampleThree from './example3.js';
import ExampleFour from './example4.js';
import ExampleFive from './example5.js';
import ExampleSix from './example6.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`Dropdowns are used to display a list of user-selectable actions or options`}{`*`}{`*`}{`
use of components don’t forget to add import `}<inlineCode parentName="p">{`legion-ui`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Dropdown } from 'legion-ui';
`}</code></pre>
    <h2>{`Variant`}</h2>
    <p>{`Legion have a six variant of dropdown`}</p>
    <h3><strong parentName="h3">{`Basic Dropdown`}</strong></h3>
    <p>{`The default of dropdown is a `}<inlineCode parentName="p">{`basic dropdown`}</inlineCode></p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "textAlign": "center"
    }}>
  <Example mdxType="Example" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useState } from 'react';
import { Dropdown, Button, DynamicIcon, Anchor } from 'legion-ui';
import './style.css';
const Example = () => {
  const [isOpen, setOpen] = useState(false);
  const toogle = () => setOpen((prev) => !prev);
  const onClose = () => setOpen(false);

  return (
    <Dropdown
      trigger={
        <Button onClick={toogle} iconRight={<DynamicIcon name="ChevronDown" />}>
          Select
        </Button>
      }
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position="center"
    >
      <div className="example-body">
        <Anchor>New File</Anchor>
        <Anchor>View Detail</Anchor>
        <Anchor>Edit File</Anchor>
        <Anchor>Save to Favorite</Anchor>
      </div>
      <div className="example-footer">
        <Anchor>Delete File</Anchor>
      </div>
    </Dropdown>
  );
};

export default Example;
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.example-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.example-menu-profile {
  text-align: left;
  line-height: 1.4;
  padding-left: 10px;
}

.example-menu-name {
  color: #1D2939;
}

.example-menu-role {
  color: #667085;
  font-size: 12px;
  font-weight: 400;
  display: block;
}

.example-body {
  padding: 8px;
  min-width: 245px;
}

.example-row {
  display: flex;
  justify-content: space-between;
}

.example-half {
  width: 50%;
}

.example-half:last-child {
  border-left: 1px solid #D0D5DD;
}

.example-half .example-body {
  min-width: 206px;
}

.example-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 156%;
  color: #1D2939;
  padding: 8px 16px;
  margin: 0;
}

.example-body a,
.example-footer a,
.example-body label,
.example-footer label {
  padding: 8px 12px;
  border-radius: 4px;
  background: #ffffff;
  white-space: nowrap;
  display: flex;
  color: #1D2939;
  font-weight: 600;
  line-height: 1.4;
}

.example-body a:hover,
.example-footer a:hover,
.example-body label:hover,
.example-footer label:hover {
  background: #F5F3FF;
  color: #1D2939;
  text-decoration: none;
}

.example-body a span:first-child,
.example-footer a span:first-child {
  margin-right: 10px;
}

.example-body a small,
.example-footer a small {
  display: block;
  width: 100%;
  font-size: 12px;
  color: #667085;
}

.example-footer {
  border-top: 1px solid #D0D5DD;
  padding: 8px;
}

.example-footer-button {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #D0D5DD;
  padding: 16px;
}
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Dropdown with Icon`}</strong></h3>
    <p>{`You can modify the `}<inlineCode parentName="p">{`dropdown`}</inlineCode>{` with icon`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "textAlign": "center"
    }}>
  <ExampleTwo mdxType="ExampleTwo" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useState } from 'react';
import { Dropdown, Button, DynamicIcon, Anchor } from 'legion-ui';
import './style.css';

const Example = () => {
  const [isOpen, setOpen] = useState(false);
  const toogle = () => setOpen((prev) => !prev);
  const onClose = () => setOpen(false);

  return (
    <Dropdown
      trigger={
        <Button onClick={toogle} iconRight={<DynamicIcon name="ChevronDown" />}>
          Select
        </Button>
      }
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position="center"
    >
      <div className="example-body">
        <Anchor iconLeft={<DynamicIcon name="FilePlus" />}>New File</Anchor>
        <Anchor iconLeft={<DynamicIcon name="Eye" />}>View Detail</Anchor>
        <Anchor iconLeft={<DynamicIcon name="Edit" />}>Edit File</Anchor>
        <Anchor iconLeft={<DynamicIcon name="Star" />}>Save to Favorite</Anchor>
      </div>
      <div className="example-footer">
        <Anchor iconLeft={<DynamicIcon name="Trash2" />}>Delete File</Anchor>
      </div>
    </Dropdown>
  );
};

export default Example;
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.example-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.example-menu-profile {
  text-align: left;
  line-height: 1.4;
  padding-left: 10px;
}

.example-menu-name {
  color: #1D2939;
}

.example-menu-role {
  color: #667085;
  font-size: 12px;
  font-weight: 400;
  display: block;
}

.example-body {
  padding: 8px;
  min-width: 245px;
}

.example-row {
  display: flex;
  justify-content: space-between;
}

.example-half {
  width: 50%;
}

.example-half:last-child {
  border-left: 1px solid #D0D5DD;
}

.example-half .example-body {
  min-width: 206px;
}

.example-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 156%;
  color: #1D2939;
  padding: 8px 16px;
  margin: 0;
}

.example-body a,
.example-footer a,
.example-body label,
.example-footer label {
  padding: 8px 12px;
  border-radius: 4px;
  background: #ffffff;
  white-space: nowrap;
  display: flex;
  color: #1D2939;
  font-weight: 600;
  line-height: 1.4;
}

.example-body a:hover,
.example-footer a:hover,
.example-body label:hover,
.example-footer label:hover {
  background: #F5F3FF;
  color: #1D2939;
  text-decoration: none;
}

.example-body a span:first-child,
.example-footer a span:first-child {
  margin-right: 10px;
}

.example-body a small,
.example-footer a small {
  display: block;
  width: 100%;
  font-size: 12px;
  color: #667085;
}

.example-footer {
  border-top: 1px solid #D0D5DD;
  padding: 8px;
}

.example-footer-button {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #D0D5DD;
  padding: 16px;
}
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Dropdown with Description`}</strong></h3>
    <p>{`You can modify the `}<inlineCode parentName="p">{`dropdown`}</inlineCode>{` with description`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "display": "flex",
      "justifyContent": "center"
    }}>
  <ExampleThree mdxType="ExampleThree" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useState } from 'react';
import { Dropdown, Button, DynamicIcon, Anchor } from 'legion-ui';
import './style.scss';
const ExampleThree = () => {
  const [isOpen, setOpen] = useState(false);
  const toogle = () => setOpen((prev) => !prev);
  const onClose = () => setOpen(false);

  return (
    <Dropdown
      trigger={
        <Button onClick={toogle} iconRight={<DynamicIcon name="ChevronDown" />}>
          Select
        </Button>
      }
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position="center"
    >
      <div className="example-body">
        <Anchor iconLeft={<DynamicIcon name="FilePlus" />}>
          <span className="example-item-hint">
            New File<small>Add your new file to draft</small>
          </span>
        </Anchor>
        <Anchor iconLeft={<DynamicIcon name="Eye" />}>
          <span className="example-item-hint">
            View Detail<small>See your detail file in draft</small>
          </span>
        </Anchor>
        <Anchor iconLeft={<DynamicIcon name="Edit" />}>
          <span className="example-item-hint">
            Edit File<small>Continue edit your file</small>
          </span>
        </Anchor>
        <Anchor iconLeft={<DynamicIcon name="Star" />}>
          <span className="example-item-hint">
            Save to Favorite<small>Add selected file to favorite</small>
          </span>
        </Anchor>
      </div>
      <div className="example-footer">
        <Anchor iconLeft={<DynamicIcon name="Trash2" />}>
          <span className="example-item-hint">
            Delete File<small>Remove selected file to trash</small>
          </span>
        </Anchor>
      </div>
    </Dropdown>
  );
};

export default ExampleThree;
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.example-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.example-menu-profile {
  text-align: left;
  line-height: 1.4;
  padding-left: 10px;
}

.example-menu-name {
  color: #1D2939;
}

.example-menu-role {
  color: #667085;
  font-size: 12px;
  font-weight: 400;
  display: block;
}

.example-body {
  padding: 8px;
  min-width: 245px;
}

.example-row {
  display: flex;
  justify-content: space-between;
}

.example-half {
  width: 50%;
}

.example-half:last-child {
  border-left: 1px solid #D0D5DD;
}

.example-half .example-body {
  min-width: 206px;
}

.example-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 156%;
  color: #1D2939;
  padding: 8px 16px;
  margin: 0;
}

.example-body a,
.example-footer a,
.example-body label,
.example-footer label {
  padding: 8px 12px;
  border-radius: 4px;
  background: #ffffff;
  white-space: nowrap;
  display: flex;
  color: #1D2939;
  font-weight: 600;
  line-height: 1.4;
}

.example-body a:hover,
.example-footer a:hover,
.example-body label:hover,
.example-footer label:hover {
  background: #F5F3FF;
  color: #1D2939;
  text-decoration: none;
}

.example-body a span:first-child,
.example-footer a span:first-child {
  margin-right: 10px;
}

.example-body a small,
.example-footer a small {
  display: block;
  width: 100%;
  font-size: 12px;
  color: #667085;
}

.example-footer {
  border-top: 1px solid #D0D5DD;
  padding: 8px;
}

.example-footer-button {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #D0D5DD;
  padding: 16px;
}
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Dropdown with Checkbox`}</strong></h3>
    <p>{`You can modify the `}<inlineCode parentName="p">{`dropdown`}</inlineCode>{` with checkbox`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "display": "flex",
      "justifyContent": "center"
    }}>
  <ExampleFour mdxType="ExampleFour" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useState } from 'react';
import { Dropdown, Button, DynamicIcon, Checkbox } from 'legion-ui';
import './style.scss';

const ExampleFour = () => {
  const [isOpen, setOpen] = useState(false);
  const toogle = () => setOpen((prev) => !prev);
  const onClose = () => setOpen(false);
  const clearSelected = () => setSelecdtedData([]);

  const provinces = ['Jawa', 'Kalimantan', 'Sumatera', 'Aceh', 'Papua'];
  const [selectedData, setSelecdtedData] = useState([]);
  const isChecked = (value) => selectedData.includes(value);
  const selectProvince = (e) => setSelecdtedData([...selectedData, e.target.value]);

  return (
    <Dropdown
      trigger={
        <Button onClick={toogle} iconRight={<DynamicIcon name="ChevronDown" />}>
          Filter
        </Button>
      }
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position="center"
    >
      <div className="example-body">
        {provinces.map((province) => (
          <Checkbox
            key={province}
            value={province}
            label={province}
            onChange={selectProvince}
            checked={isChecked(province)}
          />
        ))}
      </div>
      <div className="example-footer-button">
        <Button variant="outline" onClick={clearSelected}>
          Clear
        </Button>
        <Button style={{ marginLeft: '10px' }} onClick={onClose}>
          Submit
        </Button>
      </div>
    </Dropdown>
  );
};

export default ExampleFour;
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.example-menu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.example-menu-profile {
  text-align: left;
  line-height: 1.4;
  padding-left: 10px;
}

.example-menu-name {
  color: #1D2939;
}

.example-menu-role {
  color: #667085;
  font-size: 12px;
  font-weight: 400;
  display: block;
}

.example-body {
  padding: 8px;
  min-width: 245px;
}

.example-row {
  display: flex;
  justify-content: space-between;
}

.example-half {
  width: 50%;
}

.example-half:last-child {
  border-left: 1px solid #D0D5DD;
}

.example-half .example-body {
  min-width: 206px;
}

.example-title {
  font-weight: 700;
  font-size: 18px;
  line-height: 156%;
  color: #1D2939;
  padding: 8px 16px;
  margin: 0;
}

.example-body a,
.example-footer a,
.example-body label,
.example-footer label {
  padding: 8px 12px;
  border-radius: 4px;
  background: #ffffff;
  white-space: nowrap;
  display: flex;
  color: #1D2939;
  font-weight: 600;
  line-height: 1.4;
}

.example-body a:hover,
.example-footer a:hover,
.example-body label:hover,
.example-footer label:hover {
  background: #F5F3FF;
  color: #1D2939;
  text-decoration: none;
}

.example-body a span:first-child,
.example-footer a span:first-child {
  margin-right: 10px;
}

.example-body a small,
.example-footer a small {
  display: block;
  width: 100%;
  font-size: 12px;
  color: #667085;
}

.example-footer {
  border-top: 1px solid #D0D5DD;
  padding: 8px;
}

.example-footer-button {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #D0D5DD;
  padding: 16px;
}
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Dropdown with Multiple Categories`}</strong></h3>
    <p>{`You can modify the `}<inlineCode parentName="p">{`dropdown`}</inlineCode>{` with multiple categories`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "display": "flex",
      "justifyContent": "center"
    }}>
  <ExampleFive mdxType="ExampleFive" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useState } from 'react'
import { Dropdown, Button, DynamicIcon, Checkbox } from 'legion-ui'

const ExampleFive = () => {
  const [isOpen, setOpen] = useState(false)
  const toogle = () => setOpen(prev => !prev)
  const onClose = () => setOpen(false)
  const clearSelected = () => setSelecdtedData([])

  const categories = ['Automative', 'Electronics', 'Fashion', 'Furniture', 'Sport & Travel']
  const provinces = ['Jawa', 'Kalimantan', 'Sumatera', 'Aceh', 'Papua']
  const [selectedData, setSelecdtedData] = useState<string[]>([])
  const isChecked = (value: string) => selectedData.includes(value)
  const selectProvince = (e: React.ChangeEvent<HTMLInputElement>) => setSelecdtedData([...selectedData, e.target.value])

  return (
    <Dropdown
      trigger={<Button onClick={toogle} iconRight={<DynamicIcon name="ChevronDown" />}>Filter</Button>}
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position='center'
    >
      <div className="example-row">
        <div className="example-half">
          <div className="example-body">
            <h3 className="example-title">Category</h3>
            {categories.map( category =>
              <Checkbox key={category} value={category} label={category} onChange={selectProvince} checked={isChecked(category)}/>
            )}
          </div>
        </div>
        <div className="example-half">
            <div className="example-body">
              <h3 className="example-title">Region</h3>
              {provinces.map( province =>
                <Checkbox key={province} value={province} label={province} onChange={selectProvince} checked={isChecked(province)}/>
              )}
            </div>
        </div>
      </div>
      <div className="example-footer-button">
        <Button variant='outline' onClick={clearSelected}>Clear</Button>
        <Button style={{marginLeft: '10px'}} onClick={onClose}>Submit</Button>
      </div>
    </Dropdown>
  )
}

export default ExampleFive
`}</code></pre>
    <div className="divi" />
    <h3><strong parentName="h3">{`Dropdown with Toggle`}</strong></h3>
    <p>{`You can modify the `}<inlineCode parentName="p">{`dropdown`}</inlineCode>{` with toggle`}</p>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC",
      "display": "flex",
      "justifyContent": "center"
    }}>
  <ExampleSix mdxType="ExampleSix" />
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { useState } from 'react';
import { Dropdown, Avatar, DynamicIcon, Anchor, Button } from 'legion-ui';

const ExampleSix = () => {
  const [isOpen, setOpen] = useState(false);
  const toogle = () => setOpen((prev) => !prev);
  const onClose = () => setOpen(false);

  return (
    <Dropdown
      trigger={
        <Button iconRight={<DynamicIcon name="ChevronDown" />} variant="transparent" onClick={toogle}>
          <span className="example-menu">
            <Avatar size="medium" src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
            <span className="example-menu-profile">
              <span className="example-menu-name">Alwan Thio</span>
              <span className="example-menu-role">Administrator</span>
            </span>
          </span>
        </Button>
      }
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position="center"
    >
      <div className="example-body">
        <Anchor iconLeft={<DynamicIcon name="User" />}>Profile</Anchor>
        <Anchor iconLeft={<DynamicIcon name="Settings" />}>Settings</Anchor>
        <Anchor iconLeft={<DynamicIcon name="Edit" />}>Edit Info</Anchor>
      </div>
      <div className="example-footer">
        <Anchor iconLeft={<DynamicIcon name="LogOut" />}>Sign Out</Anchor>
      </div>
    </Dropdown>
  );
};

export default ExampleSix;
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`desc`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`borderRadius`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets border dropdown radius`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`boxShadow`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`0 0 8px rgba(0, 0, 0, 0.125)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets shadow on dropdown`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`children`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`React.ReactNode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pass all the necessary components here`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isOpen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Status that makes the dropdown appear`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onClose`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(value: boolean) ⇒ void`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to close the dropdown`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`position`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`left`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`center`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`right`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`left`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Sets position of dropdown`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trigger`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`React.ReactNode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yes`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Pass all the necessary components here`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`space`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`40`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Space between trigger and box dropdown`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`style or className`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`React.CSSProperties`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`style customization`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      